module.exports = __webpack_public_path__ + "static/media/maps.6a1965e3.png";